import React, { useEffect, useState } from "react";
import Firstchart from "../../assets/images/Capture.PNG";
import Secondvhart from "../../assets/images/secondcapture.PNG";
import Thirdimg from "../../assets/images/3screenshot.png";
import fourthimg from "../../assets/images/4 screen shot.png";
import { useSelector, useDispatch } from "react-redux";
import { addPlan } from "../../features/plan/planSlice";
import { useNavigate } from "react-router-dom";

const Chartpage = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  // console.log(user.userId);
  const [plan, setPlan] = useState([]);
  const handleOnPlanClick = (item) => {
    console.log("The Plan is :", item);
    dispatch(addPlan(item));
    localStorage.setItem("plan", JSON.stringify(item));
    navigate("/questionnaire");
  };

  return (
    <>
      <div className="chatpage">
        <div className="chartpageContent">
          <div className="topSection">
            <div className="chartHeader">
              <span>
                {" "}
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="27"
                  height="22"
                  viewBox="0 0 27 22"
                  fill="none"
                >
                  <g clip-path="url(#clip0_61_134)">
                    <path
                      d="M5.7873 13.498C5.7873 12.9657 5.59899 12.5113 5.22237 12.1346C4.84575 11.758 4.3913 11.5697 3.85901 11.5697C3.32672 11.5697 2.87227 11.758 2.49565 12.1346C2.11904 12.5113 1.93073 12.9657 1.93073 13.498C1.93073 14.0303 2.11904 14.4847 2.49565 14.8613C2.87227 15.238 3.32672 15.4263 3.85901 15.4263C4.3913 15.4263 4.84575 15.238 5.22237 14.8613C5.59899 14.4847 5.7873 14.0303 5.7873 13.498ZM8.67972 6.749C8.67972 6.21671 8.49141 5.76226 8.11479 5.38564C7.73818 5.00902 7.28372 4.82071 6.75144 4.82071C6.21915 4.82071 5.7647 5.00902 5.38808 5.38564C5.01146 5.76226 4.82315 6.21671 4.82315 6.749C4.82315 7.28128 5.01146 7.73574 5.38808 8.11235C5.7647 8.48897 6.21915 8.67728 6.75144 8.67728C7.28372 8.67728 7.73818 8.48897 8.11479 8.11235C8.49141 7.73574 8.67972 7.28128 8.67972 6.749ZM15.1274 13.9951L16.649 8.2404C16.7092 7.97928 16.6716 7.73574 16.536 7.50976C16.4004 7.28379 16.2071 7.13566 15.956 7.06535C15.7049 6.99505 15.4639 7.02769 15.2329 7.16328C15.0019 7.29886 14.8512 7.49721 14.7809 7.75833L13.2594 13.5131C12.6568 13.5633 12.1195 13.7817 11.6475 14.1684C11.1754 14.555 10.8591 15.0497 10.6984 15.6522C10.4975 16.4256 10.598 17.1587 10.9997 17.8517C11.4014 18.5447 11.9889 18.9916 12.7623 19.1925C13.5356 19.3933 14.2687 19.2929 14.9617 18.8912C15.6547 18.4894 16.1016 17.9019 16.3025 17.1286C16.4632 16.526 16.433 15.9385 16.2121 15.366C15.9911 14.7936 15.6296 14.3366 15.1274 13.9951ZM25.0701 13.498C25.0701 12.9657 24.8818 12.5113 24.5052 12.1346C24.1286 11.758 23.6741 11.5697 23.1419 11.5697C22.6096 11.5697 22.1551 11.758 21.7785 12.1346C21.4019 12.5113 21.2136 12.9657 21.2136 13.498C21.2136 14.0303 21.4019 14.4847 21.7785 14.8613C22.1551 15.238 22.6096 15.4263 23.1419 15.4263C23.6741 15.4263 24.1286 15.238 24.5052 14.8613C24.8818 14.4847 25.0701 14.0303 25.0701 13.498ZM15.4287 3.85657C15.4287 3.32428 15.2404 2.86983 14.8638 2.49321C14.4872 2.11659 14.0327 1.92828 13.5004 1.92828C12.9681 1.92828 12.5137 2.11659 12.1371 2.49321C11.7605 2.86983 11.5721 3.32428 11.5721 3.85657C11.5721 4.38886 11.7605 4.84331 12.1371 5.21993C12.5137 5.59654 12.9681 5.78485 13.5004 5.78485C14.0327 5.78485 14.4872 5.59654 14.8638 5.21993C15.2404 4.84331 15.4287 4.38886 15.4287 3.85657ZM22.1777 6.749C22.1777 6.21671 21.9894 5.76226 21.6128 5.38564C21.2362 5.00902 20.7817 4.82071 20.2494 4.82071C19.7171 4.82071 19.2627 5.00902 18.8861 5.38564C18.5095 5.76226 18.3211 6.21671 18.3211 6.749C18.3211 7.28128 18.5095 7.73574 18.8861 8.11235C19.2627 8.48897 19.7171 8.67728 20.2494 8.67728C20.7817 8.67728 21.2362 8.48897 21.6128 8.11235C21.9894 7.73574 22.1777 7.28128 22.1777 6.749ZM26.9984 13.498C26.9984 16.1193 26.2904 18.5447 24.8743 20.7743C24.6835 21.0655 24.4123 21.2111 24.0608 21.2111H2.94006C2.58855 21.2111 2.31739 21.0655 2.12657 20.7743C0.710483 18.5547 0.00244141 16.1293 0.00244141 13.498C0.00244141 11.6701 0.358973 9.92263 1.07204 8.25547C1.7851 6.58831 2.74422 5.15214 3.9494 3.94696C5.15458 2.74178 6.59075 1.78266 8.25791 1.0696C9.92507 0.356532 11.6726 0 13.5004 0C15.3283 0 17.0758 0.356532 18.743 1.0696C20.4101 1.78266 21.8463 2.74178 23.0515 3.94696C24.2566 5.15214 25.2158 6.58831 25.9288 8.25547C26.6419 9.92263 26.9984 11.6701 26.9984 13.498Z"
                      fill="#0A4D68"
                    />
                  </g>
                  <defs>
                    <clipPath id="clip0_61_134">
                      <rect width="27" height="21.2111" fill="white" />
                    </clipPath>
                  </defs>
                </svg>
                Dashboard
              </span>
            </div>
          </div>
          <div className="topSection d-none">
            <div
              className="chartHeader"
              style={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "space-between",
                // backgroundColor: "lightgray",
              }}
            >
              {plan.map((item) => {
                return (
                  <div
                    style={{
                      background: "lightblue",
                      borderRadius: "50px",
                      padding: "10px",
                      alignContent: "center",
                    }}
                    onClick={() => {
                      handleOnPlanClick(item);
                    }}
                  >
                    <h1>{item.planName}</h1>
                    <p>{item.planDescription}</p>
                  </div>
                );
              })}
            </div>
          </div>
          <div className="bottomSection">
            <div className="leftSection">
              <div className="img-div">
                {/* <span>test1</span> */}
                <img
                  src={Firstchart}
                  alt="firstchart"
                  className="firstImg img-fluid "
                />
              </div>
            </div>
            <div className="rightSection">
              <div className="rightTop">
                {/* <span>test2</span> */}
                <div className="imgDiv">
                  <img
                    src={Secondvhart}
                    alt="secondimg"
                    className="img-fluid"
                  />
                </div>
              </div>
              <div className="right-bottom">
                <div className="bottomLeft">
                  {/* <span>etetteet</span> */}
                  <img src={Thirdimg} alt="third" className="img-fluid " />
                </div>
                <div className="bottomLeft">
                  <img src={fourthimg} alt="fourthimg" className="img-fluid" />
                  {/* <span>hjhjhgkhjg</span> */}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Chartpage;
